module.exports = __webpack_public_path__ + "static/media/alberto-numericco-oficina.2f17d306.jpg";